import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});

export async function fetchPermissionsApi(page:any) {
    try {

        const response = await authService.apiCall(`${BASE_URL}/groups/permissions?page=${page}`, {
            method: 'GET',
        
        });
        ////console.log(response,'response');

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}

export async function updatePermissionApi(id: string, body: any): Promise<void> {
    try {
        const response = await authService.apiCall(`${BASE_URL}/groups/${id}`, {
            method: "PATCH",
          
            body: JSON.stringify(body),
        });
        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to create");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}

export async function fetchAllGroupApi(): Promise<any> {
    try {
     
        const response = await authService.apiCall(`${BASE_URL}/groups/getAll`, {
            method: "GET",
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}